import React, { useState, useEffect } from 'react';
import LayoutSideBar from '../../../shared/util/layout-sidebar';
import CreateNewButton from '../../../shared/components/SideBar/CreateNewButton/CreateNewButton';
import OtherItems from '../../../shared/components/SideBar/ProductsHolder/ProductsHolder';
import Axios from 'axios';
import { hostNameAndPort } from '../../../shared/util/vars';
import UserList from '../../../shared/components/SideBar/UserList/UserList';
import CouponsSideBar from '../../../shared/components/SideBar/CouponsSideBar/CouponsSideBar';
import ProfileInfoBox from '../../../shared/components/SideBar/ProfileInfoBox/ProfileInfoBox';
import BrandLogo from '../../../shared/components/SideBar/BrandLogo/BrandLogo';
import AdminPanel from '../../../shared/components/SideBar/AdminPanel/AdminPanel';
import moment from 'moment';



function ListingSideBar(props) {
  let [itemList, setItemList] = useState([]);
  let [profileDetails, setProfileDetails] = useState({});
  let [toggleSidebar, setToggleSidebar] = useState(false);
  const { section, ListingID, ListingId, authorId, authorSlug, itemId } = props;
  const [authorProfileImage, setAuthorProfileImage] = useState(props.authorProfileImage);
  const [authorName, setAuthorName] = useState(props.authorName);
  const [authorSlugLocal, setAuthorSlug] = useState(props.authorSlug);
  const [howManyTimes, setHowManyTimes] = useState(0);

  async function getOtherItems() {
    try {
      let k = authorId;
      if (!k) return;
      let itemListParams = new FormData();
      if (section === 'realestate')
        itemListParams.append('filter', JSON.stringify({ realestateAgency: k }));
      else itemListParams.append('filter', JSON.stringify({ author: k }));
      itemListParams.append('start', 0);
      itemListParams.append('count', 3);
      let options = {
        url: `${hostNameAndPort}/api/${section}/items`,
        method: 'post',
        data: itemListParams
      };
      let result = await Axios(options);
      let { data } = result;
      if (!data.error) {
        let a;
        if (section === 'realestate') {
          if (!!ListingID) a = data.items.filter(v => v.ListingID !== ListingID);
          else if (!!ListingId) a = data.items.filter(v => v.ListingId !== ListingId);
        } else a = data.items.filter(v => v.itemId !== itemId);
        a = a.map(v => ({...v, originalWebsiteSection: section}));
        if (a.length > 2) {
          a.pop();
        }
        setItemList(a);
      }
    } catch (err) {
      // Error
    }
  }

  useEffect(() => {
    getOtherItems();
  }, [itemId]);

  async function getContactInfo() {
    let u = authorId;
    if (!u) return;
    let url = `${hostNameAndPort}/api/user/contact/${u}/realestate`;
    try {
      let result = await Axios(url);
      let { data } = result;
      if (!data.error) {
        setProfileDetails(data.contact);
      }
    } catch (err) {
      // Network error
    }
  }

  async function createNewAgency() {
    try {
      if (section === 'realestate-old') return;
      let _data = new FormData();
      _data.append('item', JSON.stringify(props.listingDetails));
      let options = {
        url: `${hostNameAndPort}/api/realestate/add-agency`,
        method: 'post',
        data: _data
      };
      let result = await Axios(options);
      let { data } = result;
      if (!data.error) {
        let { slug, userName, profileImage } = data.agency;
        setAuthorName(userName);
        setAuthorProfileImage(profileImage);
        setAuthorSlug(slug);
        data.agency.entityContact = {
          profileID: slug,
          Joined: moment(new Date(data.agency.entityContact.Joined)).format('Y'),
          ...data.agency.entityContact
        };
        setProfileDetails(data.agency.entityContact);
      }
    } catch (err) {
      // Network error
    }
  }

  useEffect(() => {
      if (howManyTimes < 1)
        if (!authorSlug) {
          createNewAgency();
        } else {
          getContactInfo();
        }
      setHowManyTimes(howManyTimes + 1);
  }, [authorSlug]);

  function onToggleSidebar() {
    setToggleSidebar(true);
    setTimeout(() => {
      setToggleSidebar(false);
    }, 500);
  }

  let {
    category = 'all',
    createNewTitle = 'New Listing',
    likeList = []
  } = props;

  return (<LayoutSideBar toggleSidebar={toggleSidebar}>

    <AdminPanel
      itemType={section}
      itemSlug={props.itemSlug}
      itemId={itemId}
      isFromCarsDB={false}
      isFromRealestateDB={section === 'realestate'}
      userIsAuthorized={props.userIsAuthorized}
    />

 
    <BrandLogo
      BrandLogoImg={(<img src={authorProfileImage} alt={props.authorName} />)}
      BrandLogoName={authorName}
      BrandURL={'/' + authorSlugLocal}
    />

    <ProfileInfoBox
      infoBoxTitle={
        (props.section === 'realestate' || props.section === 'realestate-old') ? 'Listing Broker' : 'About the Author'
      }
      profileDetails={profileDetails}
    />

    <CreateNewButton
      section={"realestate"}
      title={createNewTitle}
    />

    <UserList
      UserListTitle="Who Liked This"
      userList={likeList}
      onToggleSidebar={onToggleSidebar}
    />

    <OtherItems
      title="Other Items"
      items={itemList}
      section={section}
      onToggleSidebar={onToggleSidebar}
    />

    <CouponsSideBar
      section={section}
      category={category}
    />



  </LayoutSideBar>);
}

export default ListingSideBar;